module.exports = __webpack_public_path__ + "static/media/total_roi.054df9ab.png";